var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsSupplyChain32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Supply-Chain_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Supply-Chain_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Business-Applications",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Supply-Chain_32",
    transform: "translate(8.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.996,12.05975 L20.996,19.12375 C20.996,19.30175 20.902,19.46575 20.749,19.55575 L14.999,22.92075 L14.999,21.76175 L19.996,18.83675 L19.996,12.93175 L14.999,15.85675 L14.999,14.69775 L20.243,11.62775 C20.398,11.53775 20.59,11.53675 20.745,11.62575 C20.9,11.71475 20.996,11.88075 20.996,12.05975 L20.996,12.05975 Z M4.002,18.83675 L9.011,21.77075 L9.011,22.92975 L3.249,19.55575 C3.096,19.46575 3.002,19.30175 3.002,19.12375 L3.002,12.05975 C3.002,11.88075 3.098,11.71475 3.253,11.62575 C3.408,11.53775 3.6,11.53875 3.755,11.62775 L9.011,14.70675 L9.011,15.86575 L4.002,12.93175 L4.002,18.83675 Z M17.246,18.04875 L12.241,20.84475 C12.165,20.88675 12.081,20.90775 11.997,20.90775 C11.913,20.90775 11.829,20.88675 11.753,20.84475 L6.749,18.04875 L6.749,16.90375 L11.997,19.83475 L17.246,16.90375 L17.246,18.04875 Z M12.496,26.57775 L12.497,23.61875 L11.497,23.61875 L11.496,26.57775 L1,20.12775 L1,7.77475 L11.497,13.63775 L11.497,15.91275 L12.497,15.91275 L12.497,13.63775 L22.994,7.77475 L22.994,20.12775 L12.496,26.57775 Z M11.997,1.07375 L22.469,6.92275 L11.997,12.77075 L1.525,6.92275 L11.997,1.07375 Z M23.738,6.48575 L12.241,0.06375 C12.089,-0.02125 11.905,-0.02125 11.753,0.06375 L0.256,6.48575 C0.098,6.57475 0,6.74175 0,6.92275 L0,20.40775 C0,20.58175 0.09,20.74275 0.238,20.83375 L11.735,27.89775 C11.815,27.94675 11.906,27.97175 11.997,27.97175 C12.088,27.97175 12.179,27.94675 12.259,27.89775 L23.756,20.83375 C23.904,20.74275 23.994,20.58175 23.994,20.40775 L23.994,6.92275 C23.994,6.74175 23.896,6.57475 23.738,6.48575 L23.738,6.48575 Z",
    id: "Fill-9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsSupplyChain32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Supply-Chain_32.edd51223b43d2a320c44e621b47052fe.svg";
export { ForwardRef as ReactComponent };